import { StringUtils } from 'src/app/services/utils/string.utils';

export class OrderDetailsServicesObject {


    constructor(private serviceAction: string, private serviceName: string, private serviceId: string, private itemId: string) {

    }

    public static create(): OrderDetailsServicesObject {
        return new OrderDetailsServicesObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE,
            StringUtils.NOT_AVALIABLE);
    }

    public getServicesAction() {
        return this.serviceAction;
    }

    public getServicesName() {
        return this.serviceName;
    }

    public getServicesId() {
        return this.serviceId;
    }

    public getItemId() {
        return this.itemId;
    }
}
